/*
 * Copyright (c) 2023. American Express Company
 */

// third-party
import React from 'react';

// models and services
import LiteralsService from 'src/services/literals/LiteralsService';
import { OnboardingGoal } from '../../OnboardingDrawer';
import { WelcomeViewModel } from 'src/types/view-models/onboarding/welcome.view.model';

// components
import OnboardingButtons from 'src/components/onboarding-buttons/OnboardingButtons';
import Typography from 'src/components/typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';
import WideView from 'src/components/atomic/layouts/wideView/WideView';

// icons and styles
import styles from './Welcome.module.scss';
import { PRODUCT_NAME } from 'src/utils/constants';

export default function Welcome({
    getGoalCard,
    onboardingGoals,
    startupGoals,
    welcomeNext
}: WelcomeViewModel): JSX.Element {
    const title: string = LiteralsService.getLiteral('Onboarding.welcome.title', [PRODUCT_NAME]);
    const subtitleElement: JSX.Element = (
        <div className={styles.subtitleElement}>
            <Typography variant={TypographyVariants.HEADING_M} className={styles.welcomeSubtitle}>
                {LiteralsService.getLiteral('Onboarding.welcome.subtitle')}
            </Typography>
            <p>
                <Typography variant={TypographyVariants.BODY_BOLD} className={styles.welcomeDescription}>
                    {LiteralsService.getLiteral('Onboarding.welcome.tabDescPart1', [PRODUCT_NAME])}
                </Typography>
                <Typography variant={TypographyVariants.BODY} className={styles.welcomeDescription}>
                    {LiteralsService.getLiteral('Onboarding.welcome.tabDescPart2', [PRODUCT_NAME])}
                </Typography>
            </p>
        </div>
    );

    return (
        <WideView
            title={title}
            subtitleElement={subtitleElement}
            classNameView="onboarding-drawer welcomeView"
            hideBackButton
            hasBackgroundBanner
            showFooter
        >
            <div className={styles.welcomeView}>
                <div className={styles.contentArea}>
                    {onboardingGoals.map((goal: OnboardingGoal, index: number) => {
                        return getGoalCard(startupGoals, goal, index);
                    })}
                </div>
                <OnboardingButtons
                    next={welcomeNext}
                    nextButtonTitle={LiteralsService.getLiteral('Onboarding.next')}
                    isWideView
                />
            </div>
        </WideView>
    );
}
